(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barber-pro-brands"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialize = (root) => {
      const sections = root.matches?.('.bp-brands') ? [root] : root.querySelectorAll('.bp-brands');
      sections.forEach((section) => {
        const viewport = section.querySelector('.bp-brands__viewport');
        const group = section.querySelector('.bp-brands__group');
        if (!viewport || !group || viewport.dataset.marqueeReady) return;
        viewport.dataset.marqueeReady = 'true';

        let paused = false;
        let resumeTimer;
        let previousTime = performance.now();
        const pause = () => {
          clearTimeout(resumeTimer);
          paused = true;
        };
        const resume = () => {
          if (!section.contains(document.activeElement)) paused = false;
        };

        viewport.addEventListener('mouseenter', pause);
        viewport.addEventListener('mouseleave', resume);
        viewport.addEventListener('focusin', pause);
        viewport.addEventListener('focusout', () => requestAnimationFrame(resume));
        viewport.addEventListener('touchstart', pause, { passive: true });
        viewport.addEventListener('touchend', () => {
          resumeTimer = setTimeout(resume, 1800);
        }, { passive: true });

        const frame = (now) => {
          if (!viewport.isConnected) return;
          const elapsed = Math.min(now - previousTime, 80);
          previousTime = now;
          if (!paused && !reducedMotion.matches && !document.hidden) {
            const loopWidth = group.offsetWidth;
            if (loopWidth > 0) {
              const next = viewport.scrollLeft + elapsed * 0.038;
              viewport.scrollLeft = next >= loopWidth ? next - loopWidth : next;
            }
          }
          requestAnimationFrame(frame);
        };
        requestAnimationFrame(frame);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
